import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { AirCarrierEntity } from './air-carrier.model';

export enum AirCarrierActionTypes {
  LoadAirCarriers = '[AirCarrier] Load AirCarriers',
  AddAirCarrier = '[AirCarrier] Add AirCarrier',
  UpsertAirCarrier = '[AirCarrier] Upsert AirCarrier',
  AddAirCarriers = '[AirCarrier] Add AirCarriers',
  UpsertAirCarriers = '[AirCarrier] Upsert AirCarriers',
  UpdateAirCarrier = '[AirCarrier] Update AirCarrier',
  UpdateAirCarriers = '[AirCarrier] Update AirCarriers',
  DeleteAirCarrier = '[AirCarrier] Delete AirCarrier',
  DeleteAirCarriers = '[AirCarrier] Delete AirCarriers',
  ClearAirCarriers = '[AirCarrier] Clear AirCarriers',
}

export class LoadAirCarriers implements Action {
  public readonly type = AirCarrierActionTypes.LoadAirCarriers;

  constructor(public payload: { airCarriers: AirCarrierEntity[] }) {}
}

export class AddAirCarrier implements Action {
  public readonly type = AirCarrierActionTypes.AddAirCarrier;

  constructor(public payload: { airCarrier: AirCarrierEntity }) {}
}

export class UpsertAirCarrier implements Action {
  public readonly type = AirCarrierActionTypes.UpsertAirCarrier;

  constructor(public payload: { airCarrier: AirCarrierEntity }) {}
}

export class AddAirCarriers implements Action {
  public readonly type = AirCarrierActionTypes.AddAirCarriers;

  constructor(public payload: { airCarriers: AirCarrierEntity[] }) {}
}

export class UpsertAirCarriers implements Action {
  public readonly type = AirCarrierActionTypes.UpsertAirCarriers;

  constructor(public payload: { airCarriers: AirCarrierEntity[] }) {}
}

export class UpdateAirCarrier implements Action {
  public readonly type = AirCarrierActionTypes.UpdateAirCarrier;

  constructor(public payload: { airCarrier: Update<AirCarrierEntity> }) {}
}

export class UpdateAirCarriers implements Action {
  public readonly type = AirCarrierActionTypes.UpdateAirCarriers;

  constructor(public payload: { airCarriers: Update<AirCarrierEntity>[] }) {}
}

export class DeleteAirCarrier implements Action {
  public readonly type = AirCarrierActionTypes.DeleteAirCarrier;

  constructor(public payload: { id: string }) {}
}

export class DeleteAirCarriers implements Action {
  public readonly type = AirCarrierActionTypes.DeleteAirCarriers;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearAirCarriers implements Action {
  public readonly type = AirCarrierActionTypes.ClearAirCarriers;
}

export type AirCarrierActions =
  | LoadAirCarriers
  | AddAirCarrier
  | UpsertAirCarrier
  | AddAirCarriers
  | UpsertAirCarriers
  | UpdateAirCarrier
  | UpdateAirCarriers
  | DeleteAirCarrier
  | DeleteAirCarriers
  | ClearAirCarriers;
